import {
	Col,
	FormGroup,
	Label,
	Input,
} from "reactstrap";
import { H6, Spinner } from "../../../AbstractElements";
import DropzoneCommon from "../../../Component/Learning/Common/Upload/Dropzone";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import PostCommon from "../../../Component/Learning/Common/Form/Post";
import { submitTentor } from "../../../Features/Classes/Tentor/Utils/TentorUtils";
import {
	setField,
	resetState,
} from "../../../Features/Classes/Tentor/addTentorSlice";
import Swal from "sweetalert2";
import {
	handlePhoneKeyDown,
	isValidIndonesianPhoneValue,
	normalizeIndonesianPhoneValue,
} from "../../../Utils/phoneValidation";

const TentorPostContain = (props) => {
	const dispatch = useDispatch();
	const history = useNavigate();
	const data = useSelector((state) => state.addTentor);
	const startUpload = useSelector((state) => state.addTentor.isLoading);

	// Education dinamis: array of string
	const handleAddEducation = () => {
		const updated = Array.isArray(data.education) ? [...data.education] : [];
		updated.push("");
		dispatch(setField({ field: 'education', value: updated }));
	};
	const handleRemoveEducation = (idx) => {
		const updated = [...(data.education || [])];
		updated.splice(idx, 1);
		dispatch(setField({ field: 'education', value: updated }));
	};
	const handleChangeEducation = (e, idx) => {
		const { value } = e.target;
		const updated = [...(data.education || [])];
		updated[idx] = value;
		dispatch(setField({ field: 'education', value: updated }));
	};

	// Experience dinamis: array of string
	const handleAddExperience = () => {
		const updated = Array.isArray(data.experience) ? [...data.experience] : [];
		updated.push("");
		dispatch(setField({ field: 'experience', value: updated }));
	};
	const handleRemoveExperience = (idx) => {
		const updated = [...(data.experience || [])];
		updated.splice(idx, 1);
		dispatch(setField({ field: 'experience', value: updated }));
	};
	const handleChangeExperience = (e, idx) => {
		const { value } = e.target;
		const updated = [...(data.experience || [])];
		updated[idx] = value;
		dispatch(setField({ field: 'experience', value: updated }));
	};

	const handleSuccess = () => {
		dispatch(resetState());
		history(`${process.env.PUBLIC_URL}/classes/tentor-list`);
	};
	const handleSubmit = (e) => {
		e.preventDefault();
		const educationArr = Array.isArray(data.education) ? data.education : [];
		const experienceArr = Array.isArray(data.experience) ? data.experience : [];
		const isEmptyEducation = educationArr.some((element) => element === "" || element === undefined);
		const isEmptyExperience = experienceArr.some((element) => element === "" || element === undefined);
		let errorMessage = "";
		if (data.name === "") {
			errorMessage = "Nama belum diisi.";
		} else if (data.phone === "") {
			errorMessage = "Nomer Telpon belum diisi.";
		} else if (!isValidIndonesianPhoneValue(data.phone)) {
			errorMessage = "Nomer Telpon harus diawali 08 dan berisi 10-13 digit angka.";
		} else if (data.mastered_fields === "") {
			errorMessage = "Bidang Keahlian belum diisi.";
		} else if (isEmptyEducation) {
			errorMessage = "Riwayat Pendidikan belum diisi.";
		} else if (isEmptyExperience) {
			errorMessage = "Riwayat Pengalaman belum diisi.";
		}

		if (data.name === "" || data.mastered_fields === "" || data.phone === "" || isEmptyEducation || isEmptyExperience) {
			Swal.fire({
				icon: "error",
				title: "Oops...",
				text: errorMessage,
			});
		} else {
			dispatch(submitTentor({ ...data, successCallback: handleSuccess }));
		}
	};
	const handleDiscard = (e) => {
		e.preventDefault();
		dispatch(resetState());
		history(`${process.env.PUBLIC_URL}/classes/tentor-list`);
	};
	const handleChanges = (e) => {
		const { name, value } = e.target;
		const nextValue = name === "phone" ? normalizeIndonesianPhoneValue(value) : value;
		dispatch(setField({ field: name, value: nextValue }));
	};

	const handleChangeStatus = (e) => {
		const { value } = e.target;
		dispatch(setField({ field: "status", value: value }));
	};

	const handleUploadPhoto = ({ meta, file }, status) => {
		if (status === "done") {
			dispatch(setField({ field: "photo", value: file }));
		} else if (status === "removed") {
			dispatch(setField({ field: "photo", value: null }));
		}
	};

	return (
		<PostCommon
			title={props.label}
			handleSubmit={handleSubmit}
			handleDiscard={handleDiscard}>
			{startUpload ? (
				<Col lg="12">
					<div className="loader-box">
						<Spinner attrSpinner={{ className: "loader-30" }} />
					</div>
					<H6 attrH6={{ className: "sub-title mb-0 text-center" }}>
						{"Sedang proses unggah..."}
					</H6>
				</Col>
			) : (
				<div>
					<Col sm="12">
						<FormGroup className="mb-3">
							<Label for="name" style={{ fontWeight: "bold" }}>
								Nama :
							</Label>
							<Input
								className="form-control"
								id="name"
								type="text"
								name="name"
								placeholder="Masukkan nama tentor..."
								value={data.name}
								onChange={handleChanges}
							/>
						</FormGroup>
						<FormGroup className="mb-3">
							<Label for="phone" style={{ fontWeight: "bold" }}>
								Nomer Telepon :
							</Label>
							<Input
								className="form-control"
								id="phone"
								type="tel"
								name="phone"
								placeholder="Contoh: 081234567890"
								required
								inputMode="numeric"
								autoComplete="tel"
								minLength={10}
								maxLength={13}
								pattern="08[0-9]{8,11}"
								onKeyDown={handlePhoneKeyDown}
								value={data.phone}
								onChange={handleChanges}
							/>
						</FormGroup>
						<FormGroup className="mb-3">
							<Label for="email" style={{ fontWeight: "bold" }}>
								Email :
							</Label>
							<Input
								className="form-control"
								id="email"
								type="text"
								name="email"
								placeholder="Masukkan email tentor..."
								value={data.email}
								onChange={handleChanges}
							/>
						</FormGroup>
						<FormGroup className="mb-3">
							<Label for="password" style={{ fontWeight: "bold" }}>
								Password :
							</Label>
							<Input
								className="form-control"
								id="password"
								type="text"
								name="password"
								placeholder="Masukkan password tentor..."
								value={data.password}
								onChange={handleChanges}
							/>
						</FormGroup>
						<FormGroup className='mb-3'>
							<Label style={{ fontWeight: 'bold' }}>Status Tentor :</Label>
							<div className="m-checkbox-inline">
								<Label for="active">
									<Input className="radio_animated" id="active" type="radio" value="active"
										checked={data.status === 'active'}
										onChange={handleChangeStatus}
									/>
									Aktif
								</Label>
								<Label for="inactive">
									<Input className="radio_animated" id="inactive" type="radio" value="inactive"
										checked={data.status === 'inactive'}
										onChange={handleChangeStatus}
									/>
									Tidak Aktif
								</Label>
							</div>
						</FormGroup>
						<FormGroup className="mb-3">
							<Label for="mastered_fields" style={{ fontWeight: "bold" }}>
								Bidang :
							</Label>
							<Input
								className="form-control"
								id="mastered_fields"
								type="text"
								name="mastered_fields"
								placeholder="Masukkan keahlian bidang..."
								required
								value={data.mastered_fields}
								onChange={handleChanges}
							/>
						</FormGroup>
						{/* <FormGroup className="mb-3">
							<Label for="position" style={{ fontWeight: "bold" }}>
								Jabatan :
							</Label>
							<Input
								className="form-control"
								id="position"
								type="text"
								name="position"
								placeholder="Masukkan jabatan..."
								value={data.position || ''}
								onChange={handleChanges}
							/>
						</FormGroup> */}

						{/* Education array dinamis */}
						<FormGroup className="mb-3">
							<Label style={{ fontWeight: "bold" }}>Riwayat Pendidikan :</Label>
							{Array.isArray(data.education) && data.education.length > 0 && data.education.map((edu, idx) => (
								<div key={idx} className="row g-2 mb-2">
									<Input
										className="form-control"
										type="text"
										placeholder="Contoh: Magister Pendidikan Bahasa dan Sastra Indonesia, Fakultas Bahasa, Seni, dan Budaya - UNY"
										value={edu}
										onChange={e => handleChangeEducation(e, idx)}
									/>
									<div className="col-md-1 d-flex align-items-center">
										{idx > 0 && (
											<button type="button" className="btn btn-link text-danger p-0" onClick={() => handleRemoveEducation(idx)}>
												<i className="fa fa-close fa-lg"></i>
											</button>
										)}
									</div>
								</div>
							))}
							<button
								type="button"
								className="btn btn-link p-0"
								onClick={handleAddEducation}
								disabled={Array.isArray(data.education) && data.education.some(e => !e || e.trim() === "")}
							>
								<i className="fa fa-plus-circle fa-lg" style={{ color: '#3C6F7D' }}></i> Tambah Pendidikan
							</button>
						</FormGroup>
						{/* Experience array dinamis */}
						<FormGroup className="mb-3">
							<Label style={{ fontWeight: "bold" }}>Riwayat Pengalaman :</Label>
							{Array.isArray(data.experience) && data.experience.length > 0 && data.experience.map((exp, idx) => (
								<div key={idx} className="row g-2 mb-2">
									<Input
										className="form-control"
										type="text"
										placeholder="Contoh: Mengajar di SMA Negeri 1 Yogyakarta, 2018-2022"
										value={exp}
										onChange={e => handleChangeExperience(e, idx)}
									/>
									<div className="col-md-1 d-flex align-items-center">
										{idx > 0 && (
											<button type="button" className="btn btn-link text-danger p-0" onClick={() => handleRemoveExperience(idx)}>
												<i className="fa fa-close fa-lg"></i>
											</button>
										)}
									</div>
								</div>
							))}
							<button
								type="button"
								className="btn btn-link p-0"
								onClick={handleAddExperience}
								disabled={Array.isArray(data.experience) && data.experience.some(e => !e || e.trim() === "")}
							>
								<i className="fa fa-plus-circle fa-lg" style={{ color: '#3C6F7D' }}></i> Tambah Pengalaman
							</button>
						</FormGroup>
						{data.photo_url && (
							<FormGroup className="mb-3">
								<Label for="mastered_fields" style={{ fontWeight: "bold" }}>
									Foto Saat Ini :
								</Label>
								<img
									src={data.photo_url}
									alt="Foto Tentor"
									style={{ width: "300px", height: "auto", borderRadius: "5px" }}
								/>
							</FormGroup>
						)}
						<FormGroup className="mb-3">
							<DropzoneCommon
								label={"Foto Tentor"}
								inputContent={
									data.photo_url
										? "Upload Foto Baru"
										: "Silahkan Upload Foto Tentor"
								}
								handleChangeStatus={handleUploadPhoto}
								accept="image/*"
							/>
						</FormGroup>
					</Col>
				</div>
			)}
		</PostCommon>
	);
};

export default TentorPostContain;
